<template>
  <div>
    <div v-if="areaid">
      <img :src="require('@/images/svg/' + getIcon(areaid).src)" height="180" :title="getIcon(areaid).title" />
    </div>
    <div v-else>
      {{ areaid }}
    </div>
  </div>
</template>

<script>
  export default {
    name: 'FBicon',
    data () {
      return {
        iconArray: [
          {
            id: 2,
            title: 'Logistik',
            src: 'logistik_w.svg'
          },
          {
            id: 4,
            title: 'Biowissenschaften',
            src: 'dna_w.svg'
          },
          {
            id: 5,
            title: 'Telematik',
            src: 'telematik_w.svg'
          },
          {
            id: 6,
            title: 'Optische Technologien',
            src: 'optik_w.svg'
          },
          {
            id: 7,
            title: 'Produktion und Material',
            src: 'prod-mat_w.svg'
          },
          {
            id: 8,
            title: 'Management und Recht',
            src: 'recht-mang_w.svg'
          },
          {
            id: 9,
            title: 'Effektive Verwaltung',
            src: 'ff03.svg'
          },
          {
            id: 10,
            title: 'Nachhaltige Wert(e)schöpfung',
            src: 'ff02.svg'
          },
          {
            id: 11,
            title: 'Zukunftsfähige Mobilität',
            src: 'ff01.svg'
          }                                             
        ]
      }
    },
    props: {
      areaid: {
        // type: Array
      }
    },    
    methods:{
      getIcon (id) {
        return this.iconArray.find((i) => i.id === id);
      }

    },
    mounted() {
        //console.log("Mounted contacts module");
        //console.log(this.contacts);            
    } 
  }
</script>

<style>

</style>
